import React from "react";

import Card from "../Card";

import ReactTable from "react-table";

import FetchHelper from "../../../utils/FetchHelper";
import General from "../../../utils/General";
import Notify from "../../../utils/Notify";

import "react-table/react-table.css";

const OBJECTS_FILTERS = {
  name: {
    api: "objects",
    display: "Status",
  },
  values: [
    {
      label: "All",
      value: "all",
    },
    {
      label: "Active",
      value: "active",
    },
    {
      label: "Hidden",
      value: "deleted",
    },
  ],
};

export default class BaseTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      data: [],
      pagesNo: 0,
      searchTerm: this.props.searchTerm || "",
      csvData: [],
      filterValue: { objects: "active" },
      searchFilter: this.props.searchFilter,
      filters: this.props.filters ? [...this.props.filters] : [],
      extraParams: this.props.extraParams || {},
    };

    this.reactTable = React.createRef();
    this.csvLink = React.createRef();
    this.manualReload = this.manualReload.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const oldExtraParams = JSON.stringify(this.props.extraParams || {});
    const newExtraParams = JSON.stringify(nextProps.extraParams || {});

    if (oldExtraParams !== newExtraParams) {
      this.setState({ extraParams: nextProps.extraParams || {} }, () => {
        this.manualReload();
      });
    }

    if (nextProps.endpoint !== this.props.endpoint) {
      this.refresh();
    }

    if (nextProps.searchTerm !== this.props.searchTerm) {
      this.setState({ searchTerm: nextProps.searchTerm || "" }, () => {
        this.manualReload();
      });
    }
  }

  refresh() {
  const current = this.reactTable.current;

  if (current) {
    this.setState({ pagesNo: 1, loading: false }, () => {
      this._fetchData(current.state, current);
    });
  }
}

  // _handleSearch = General.debounce(() => {
  //   let current = this.reactTable.current;
  //   this.setState({ updated: !this.state.updated });
  // }, 500);

  _handleSearch = General.debounce(() => {
  this.manualReload();
}, 500);

//   manualReload = () => {
//   console.log("manualReload triggered. Reloading table...");

//   const current = this.reactTable.current;

//   if (current) {
//     this._fetchData(current.state, current);
//   }
// };

manualReload = () => {
  console.log("manualReload triggered. Reloading table...");

  const current = this.reactTable.current;

  if (current) {
    const tableState = {
      ...current.state,
      page: 0, // reset to first page when searching/filtering
    };

    this._fetchData(tableState, current);
  }
};

  _handleFilterChange(event) {
    let { filterValue } = this.state;

    filterValue[event.target.name] = event.target.value;
    this.setState({ filterValue }, () => this._handleSearch());
  }

  _getUrl(endpoint, state) {
    let params = {
      ...this.props.params,
      page_size: state.pageSize,
      page: state.page + 1,
      pagination_type: "page",
      search_term: this.props.searchTerm || this.state.searchTerm,
    };

    // Inject external params (e.g., start_date, end_date)
    params = {
      ...params,
      ...this.state.extraParams,
    };

    let sorted = state.sorted[0];
    if (sorted) {
      let orderBy = sorted.id;
      orderBy = orderBy.replace(/\./g, "__");
      if (sorted.desc) {
        orderBy = `-${orderBy}`;
      }
      params["order_by"] = orderBy;
    }

    if (this.state.filterValue) {
      Object.entries(this.state.filterValue).forEach((filter) => {
        params[filter[0]] = filter[1];
      });
    }

    return this._addParams(endpoint, params);
  }

  _fetchData(state, instance) {
    const notifyLoadingChange = (status) => {
      if (typeof this.props.onLoadingChange === "function") {
        this.props.onLoadingChange(status);
      }
    };

    this.setState({ loading: true });
    notifyLoadingChange(true);
    let url = this._getUrl(this.props.endpoint, state);
    console.log("BaseTable _fetchData url: ", url);

    if (this.props.endpoint === "") {
      this.setState({
        data: this.props.mockData,
        pagesNo: 1,
        loading: false,
      });
      notifyLoadingChange(false);
      return;
    }



FetchHelper.get(url, false)
  .then((response) => {
    console.log("Fetched driver list:", response.results);

    let results = response.results || [];

    const extraParams = this.state.extraParams || {};

    console.log("ExtraParams coming ... : ", extraParams);

    if (
      extraParams.start_date ||
      extraParams.end_date ||
      extraParams.driver_id ||
      extraParams.month ||
      extraParams.year ||
      extraParams.application_status
    ) {
      const start = extraParams.start_date
        ? new Date(extraParams.start_date + "T00:00:00")
        : null;

      const end = extraParams.end_date
        ? new Date(extraParams.end_date + "T23:59:59")
        : null;

      const filterDriverName = extraParams.driver_id
        ? String(extraParams.driver_id).trim().toLowerCase()
        : null;

      const filterMonth = extraParams.month ? Number(extraParams.month) : null;

      const filterYear = extraParams.year ? Number(extraParams.year) : null;

      // ✅ NEW: application status filter
      const filterApplicationStatus = extraParams.application_status
        ? String(extraParams.application_status).trim().toLowerCase()
        : null;

      results = results.filter((row) => {
        // ✅ APPLICATION STATUS
        if (filterApplicationStatus) {
          const rowApplicationStatus = String(
            row?.application_status ||
              row?.user?.application_status ||
              row?.driver?.application_status ||
              ""
          )
            .trim()
            .toLowerCase();

          if (rowApplicationStatus !== filterApplicationStatus) {
            return false;
          }
        }

        // DATE / MONTH / YEAR filters only need created_at
        if (start || end || filterMonth || filterYear) {
          if (!row.created_at) return false;

          const createdAt = new Date(row.created_at);

          // DATE RANGE
          if (start && createdAt < start) return false;
          if (end && createdAt > end) return false;

          // MONTH
          if (filterMonth && createdAt.getMonth() + 1 !== filterMonth) {
            return false;
          }

          // YEAR
          if (filterYear && createdAt.getFullYear() !== filterYear) {
            return false;
          }
        }

        // DRIVER NAME
        if (filterDriverName) {
          if (!row.driver || !row.driver.user) return false;

          const rowDriverName =
            `${row.driver.user.first_name} ${row.driver.user.last_name}`
              .trim()
              .toLowerCase();

          if (rowDriverName !== filterDriverName) return false;
        }

        return true;
      });
    }
  this.setState({
  data: results,
  pagesNo: Math.ceil(response.count / state.pageSize),
  totalRecords: response.count,
  loading: false,
});

notifyLoadingChange(false);

if (this.props.onOrdersLoaded) {
  this.props.onOrdersLoaded(results);
}

if (this.props.onDataLoaded) {
  this.props.onDataLoaded(results);
}

if (this.props.onTotalRecordsChange) {
  this.props.onTotalRecordsChange(response.count, results, response);
}
  })
  .catch((error) => {
    console.error("Fetch error in BaseTable: ", error);
    this.setState({ loading: false });
    notifyLoadingChange(false);
  });}

  // _addParams(url, params) {
  //   if (Object.keys(params).length === 0) {
  //     return url;
  //   }

  //   // TODO: switch to an actual url helper here to avoid bugs/edge cases
  //   if (url.indexOf("?") === -1) {
  //     url += "?";
  //   } else if (!url.endsWith("&")) {
  //     url += "&";
  //   }

  //   Object.keys(params).forEach(function (key) {
  //     url += key + "=" + params[key] + "&";
  //   });

  //   // remove last '&'
  //   url = url.slice(0, -1);
  //   return url;
  // }

  _addParams(url, params) {
  const query = Object.keys(params)
    .filter((key) => params[key] !== undefined && params[key] !== null && params[key] !== "")
    .map((key) => {
      return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
    })
    .join("&");

  if (!query) {
    return url;
  }

  return url.indexOf("?") === -1 ? `${url}?${query}` : `${url}&${query}`;
}

  _exportPressed = () => {
    console.log("BaseTable _exportPressed!");
    const { data } = this.state;

    console.log("BaseTable _exportPressed data: ", data);
    if (!data || data.length === 0) {
      Notify.error("No filtered data available to export.");
      return;
    }

    try {
      // Auto filename
      const fileNameBase = `Drivers_Payroll_Filtered_${new Date()
        .toISOString()
        .slice(0, 10)}`;

      // CSV EXPORT
      const csvHeaders = Object.keys(data[0]);
      const csvRows = [
        csvHeaders.join(","),
        ...data.map((row) =>
          csvHeaders
            .map((key) => {
              let value = row[key];
              if (typeof value === "object") value = JSON.stringify(value);
              return `"${value ?? ""}"`;
            })
            .join(",")
        ),
      ].join("\n");

      const csvBlob = new Blob([csvRows], { type: "text/csv;charset=utf-8;" });
      const csvLink = document.createElement("a");
      csvLink.href = URL.createObjectURL(csvBlob);
      csvLink.download = `${fileNameBase}.csv`;
      csvLink.click();

      // XLSX EXPORT
      const XLSX = require("xlsx");
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Payroll");
      XLSX.writeFile(workbook, `${fileNameBase}.xlsx`);

      Notify.success("Export completed (Filtered Data Only).");
    } catch (error) {
      console.error("Export error:", error);
      Notify.error("Export failed.");
    }
  };

  _renderHeaderLeftContent() {
    let { filters } = this.state;

    return (
      <>
        <div class="col">
          <div className="input-icon">
            {/* <input
              type="text"
              className="form-control"
              placeholder={this.props.searchPlaceholder}
              onChange={(e) => {
                this.setState(
                  {
                    searchTerm: e.target.value,
                  },
                  () => this._handleSearch()
                );
              }}
            /> */}

            <input
                type="text"
                className="form-control"
                placeholder={this.props.searchPlaceholder}
                value={this.state.searchTerm}
                onChange={(e) => {
                  this.setState(
                    {
                      searchTerm: e.target.value,
                    },
                    () => this._handleSearch()
                  );
                }}
              />

            <span>
              <i className="flaticon2-search-1 text-muted"></i>
            </span>
          </div>
        </div>
        {filters &&
          filters.map((filter) => {
            return (
              <div className="col my-2 my-md-0">
                <div className="d-flex align-items-center">
                  <label className="mr-3 mb-0 d-none d-md-block">
                    {General.toTitleCase(filter.name.display)}:
                  </label>
                  <select
                    className="form-control"
                    name={filter.name.api}
                    onChange={(e) => {
                      this._handleFilterChange(e);
                    }}
                    defaultValue={this.props.searchFilter}
                  >
                    {filter.values.map((filterOptions) => {
                      return (
                        <option value={filterOptions.value || ""}>
                          {filterOptions.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            );
          })}
      </>
    );
  }

  render() {
    const { data, pagesNo, loading, totalRecords } = this.state;
    // const { searchTerm } = this.props;

    // const filteredData = !searchTerm
    //   ? data
    //   : data.filter((row) => {
    //       const q = searchTerm.toLowerCase();
    //       return JSON.stringify(row).toLowerCase().includes(q);
    //     });

    const filteredData = data;

    // Determine the column count dynamically for use in the SubComponent integration logic
    const columnCount = this.props.columns ? this.props.columns.length : 0;

    return (
      <Card
        title={this.props.title}
        icon={this.props.icon}
        renderToolbar={this.props.renderToolbar()}
        className={this.props.className}
        loading={loading}
        showHeader={this.props.showHeader}
        showExport={this.props.showExport}
        onExportClicked={() => this._exportPressed()}
      >
        <div style={{ overflowX: "auto" }}>
          {this.props.showFilter && this.props.showSearch && (
            <div class="row mb-7">
              <div class="col-md-12">
                <div class="dataTables_filter">
                  <div className="row">{this._renderHeaderLeftContent()}</div>
                </div>
              </div>
            </div>
          )}
          <ReactTable
            // key={this.state.updated}
            ref={this.reactTable}
            manual
            data={filteredData}
            pages={pagesNo}
            totalRecords={totalRecords}
            loading={loading}
            LoadingComponent={Loading}
            onFetchData={this._fetchData.bind(this)}
            columns={this.props.columns}
            getTdProps={this.props.getTdProps}
            getTrProps={this.props.getTrProps}
            getTheadProps={this.props.getTheadProps}
            getTheadThProps={this.props.getTheadThProps}
            showPagination={this.props.showPagination}
            showPaginationTop={this.props.showPaginationTop}
            showPaginationBottom={this.props.showPaginationBottom}
            defaultSorted={this.props.defaultSorted}
            // SubComponent={this.props.SubComponent}
            // Pass column count into SubComponent for reliable colSpan calculation in the consuming component
            SubComponent={(rowInfo) => {
              if (this.props.SubComponent) {
                // Pass columnCount explicitly to help consuming component calculate colSpan
                return this.props.SubComponent({
                  ...rowInfo,
                  columnCount: columnCount,
                });
              }
              return null;
            }}
            NoDataComponent={() => {
              return (
                <div className="rt-noData">{this.props.noDataMessage}</div>
              );
            }}
            style={{
              width: "100%",
            }}
          />
        </div>
      </Card>
    );
  }
}

BaseTable.defaultProps = {
  params: {},
  extraParams: {}, // <--- ADD THIS
  label: "Search:",
  searchPlaceholder: "Search...",
  showHeader: true,
  showFilter: true,
  icon: null,
  filters: null,
  searchFilter: null,
  searchFilterName: "name",
  noDataMessage: "No documents found",
  showSearch: true,
  showPagination: true,
  showPaginationTop: false,
  showPaginationBottom: true,
  showExport: false,
  onOrdersLoaded: null, 
  onTotalRecordsChange: null,
  getTdProps: (state, rowInfo, column, instance) => {
    return {
      style: {
        paddingLeft: 10,
      },
    };
  },
  getTrProps: (state, rowInfo, column, instance) => {
    return {
      style: {
        paddingTop: 10,
        paddingBottom: 10,
      },
    };
  },
  getTheadProps: (state, rowInfo, column, instance) => {
    return {
      style: {
        boxShadow: "0 1px 1px 0 rgba(0,0,0,0.1)",
        paddingTop: 10,
        paddingBottom: 10,
        textAlign: "left",
      },
    };
  },
  getTheadThProps: (state, rowInfo, column, instance) => {
    return {
      style: {
        textAlign: "left",
        paddingLeft: 10,
      },
    };
  },
  SubComponent: null,
  renderHeaderRightContent: () => null,
  renderToolbar: () => null,
  onLoadingChange: () => {},
};

class Loading extends React.Component {
  render() {
    return this.props.loading ? (
      <div className="-loading -active">
        <div className="-loading-inner"></div>
      </div>
    ) : null;
  }
}
